import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;
const API = BACKEND_URL.endsWith('/api') ? BACKEND_URL : BACKEND_URL.endsWith('/') ? `${BACKEND_URL}api` : `${BACKEND_URL}/api`;

const getHeaders = (currentUser) => ({
  'X-User-Id': currentUser?.id,
  'X-Session-Token': currentUser?.session_token
});

export const chequeService = {
  getCheques: async (currentUser, params = {}) => {
    try {
      const response = await axios.get(`${API}/cheques/`, {
        headers: getHeaders(currentUser),
        params
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching cheques', error);
      throw error;
    }
  },

  getStats: async (currentUser) => {
    try {
      const response = await axios.get(`${API}/cheques/stats`, {
        headers: getHeaders(currentUser)
      });
      return response.data;
    } catch (error) {
      console.error('Error fetching cheque stats', error);
      throw error;
    }
  },

  createCheque: async (currentUser, data) => {
    try {
      const response = await axios.post(`${API}/cheques/`, data, {
        headers: getHeaders(currentUser)
      });
      return response.data;
    } catch (error) {
      console.error('Error creating cheque', error);
      throw error;
    }
  },

  updateCheque: async (currentUser, id, data) => {
    try {
      const response = await axios.put(`${API}/cheques/${id}`, data, {
        headers: getHeaders(currentUser)
      });
      return response.data;
    } catch (error) {
      console.error('Error updating cheque', error);
      throw error;
    }
  },

  deleteCheque: async (currentUser, id) => {
    try {
      const response = await axios.delete(`${API}/cheques/${id}`, {
        headers: getHeaders(currentUser)
      });
      return response.data;
    } catch (error) {
      console.error('Error deleting cheque', error);
      throw error;
    }
  }
};
